import styles from './SavedSearchIllustration.module.css';

import {
  SAVED_SEARCH_MODAL_VIDEO,
  SAVED_SEARCH_MODAL_VIDEO_POSTER,
} from '@/modules/savedSearch/constants';

export function SavedSearchIllustration() {
  return (
    <video
      className={styles.video}
      playsInline
      webkit-playsinline="true"
      muted
      loop
      autoPlay
      preload="metadata"
      poster={SAVED_SEARCH_MODAL_VIDEO_POSTER}
      aria-hidden="true"
    >
      <source
        src={SAVED_SEARCH_MODAL_VIDEO}
        type="video/mp4"
        media="(prefers-reduced-motion: no-preference)"
      />
    </video>
  );
}
